import React from 'react';
import { Helmet } from 'react-helmet-async';
import Products from '../components/Products';
import Footer from '../components/Footer';

const SigortaUrunleri = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50">
      <Helmet>
        <title>Sigorta Ürünleri ve Hizmetlerimiz | SigortamOlsun</title>
        <meta 
          name="description" 
          content="Araç, konut, sağlık ve iş yeri sigortaları. En uygun fiyat garantisiyle tüm sigorta ihtiyaçlarınız için tek adres." 
        />
        <link rel="canonical" href="https://sigortamolsun.com/sigorta-urunleri" />
      </Helmet>

      <Products />
      <Footer />
    </div>
  );
};

export default SigortaUrunleri;